import { AppState } from 'src/app/core/core.state';
import { ResourceEffects } from 'src/app/shared/resource-effects';

import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';

import { Site } from './site';
import { siteActions } from './site.actions';
import * as fromSite from './site.reducer';
import { SiteService } from './site.service';

@Injectable()
export class SiteEffects extends ResourceEffects<Site> {
  constructor(
    public actions$: Actions,
    public store: Store<AppState>,
    public siteService: SiteService
  ) {
    super(fromSite.FEATURE_NAME, siteService, siteActions, actions$)
  }
}
